import type React from 'react';
import PreviewTabs from 'src/components/Tabs/PreviewTabs/PreviewTabs';
import TabPane from 'src/components/Tabs/TabPane/TabPane';
import { DETAILS_PANEL_VIEW_MODEL_COMP_NAME, INFO_PANEL_VIEW_MODEL_COMP_NAME } from 'src/constants';
import Tab from '../Tab';

interface Asset {
  id: string;
  [key: string]: unknown;
}

interface SimpleItemTabProps {
  asset: Asset;
  shared?: boolean;
}

const SimpleItemTab: React.FC<SimpleItemTabProps> = ({ asset, shared = false }) => {
  return (
    <PreviewTabs>
      <TabPane name="Info" key="1">
        <Tab
          isTwoColumn={true}
          itemId={asset.id}
          edit={false}
          viewModelName={INFO_PANEL_VIEW_MODEL_COMP_NAME}
          shared={shared}
        />
      </TabPane>
      <TabPane name="Details" key="2">
        <Tab
          isTwoColumn={true}
          itemId={asset.id}
          edit={false}
          viewModelName={DETAILS_PANEL_VIEW_MODEL_COMP_NAME}
          shared={shared}
        />
      </TabPane>
    </PreviewTabs>
  );
};

export default SimpleItemTab;
